/*
 * AppReducer
 *
 * The reducer takes care of main app data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import { combineReducers } from 'redux-immutable';
import { Map } from 'immutable';
import type { AnyAction, Reducer } from 'redux';
import { featureTogglesReducer } from '../Admin/FeatureToggles/reducer';

const combinedAppReducer = combineReducers({
  featureToggles: featureTogglesReducer,
});

const isImmutableMap = (value: unknown): value is Map<string, unknown> =>
  Map.isMap(value);

const appReducer: Reducer<Map<string, unknown>, AnyAction> = (state, action) => {
  const nextState: unknown = Reflect.apply(combinedAppReducer, undefined, [
    state,
    action,
  ]);

  if (!isImmutableMap(nextState)) {
    throw new TypeError('Expected the app reducer to return an Immutable Map');
  }

  return nextState;
};

export default appReducer;
